/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { BlurSpinner } from "../../../BlurSpinner";
import { TemplateHeader, Container, CustomLabel } from "../../styles";
import { InputText } from "../../../../ui/inputs";
import { LabSelect } from "../../../course/select";
import { createRelevoAdministrativo, getRelevoAdministrativoById, updateRelevoAdministrativo } from "../../../../services/relevoAdministrativoServices";
import { relevoDePerfilCategories } from "../../../../services/relevoDePerfilServices";
import { getSubclientsByClientId } from "../../../../services/clientesServices";
import { handleErrors } from "../../../../services/handleErrors";
import useFetcher from "../../../../hooks/useFetcher";
import { formatNumeroDeLegajo } from "../../../course/segmentationClientGropuModal/clientGroupForm";
import { fetchCompanias } from "../../../../services/companiaServices";
import CancelFormModal from "../../cancelFormModal";
import { ButtonPrimary } from "../../../../ui/buttons";

export const createOrUpdateRelevo = async (data, id) => {
  if (id) {
    const res = await updateRelevoAdministrativo(id, data);
    return res;
  }
  const res = await createRelevoAdministrativo(data);
  return res;
};

export default function RelevoAdministrativoForm({ clientId, toggle, reloadRelevos, relevoId }) {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [fechaTCEnumValue, setFechaTCEnumValue] = useState("");
  const [fechaEntregaTXTEnumValue, setFechaEntregaTXTEnumValue] = useState("");
  const [fechaCorteNovedadesEnumValue, setFechaCorteNovedadesEnumValue] = useState("");
  const [fechaPagoEnumValue, setFechaPagoEnumValue] = useState("");
  const [fechaAnticipoFacturaEnumValue, setFechaAnticipoFacturaEnumValue] = useState("");
  const [valuesFromEdit, setValuesFromEdit] = useState("");
  const [subclients, isLoadingSubclients] = useFetcher(getSubclientsByClientId, [clientId]);
  const [companias, isLoadingCompanias] = useFetcher(fetchCompanias, undefined, "fetchCompanias");
  const [razonSocialAdeccoValues, setRazonSocialAdeccoValues] = useState("");
  const [categories, isLoadingCategories] = useFetcher(relevoDePerfilCategories, undefined, "relevoDePerfilCategories");

  const [subclientsValues, setSubclientesValues] = useState([]);

  useEffect(async () => {
    if (relevoId) {
      const { result } = await getRelevoAdministrativoById(relevoId);

      const currentValues = {
        ...result,
      };
      setValuesFromEdit(currentValues);
    }
  }, [relevoId]);

  const subClientOptions =
    subclients && subclients.length > 0
      ? subclients
          .map((e) => {
            return { label: `${formatNumeroDeLegajo(e.numeroDeLegajo)}`, value: e.itemId };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const razonSocialAdeccoOptions =
    companias && companias.length > 0
      ? companias
          .map((e) => {
            return { label: `${e.text}`, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const fechasClientesNuevosOptions =
    categories && categories.entregaFC && categories.entregaFC.type.length > 0
      ? categories.entregaFC.type.map((e) => ({ label: e.text, value: e.id })).sort((a, b) => (a.value > b.value ? 1 : -1))
      : [];

  const getFunctionToFilter = (filter, selected) => {
    if (filter === "subclients") {
      setSubclientesValues(selected);
    }
    if (filter === "razonSocialAdecco") {
      setRazonSocialAdeccoValues(selected);
    }
    if (filter === "fechaTCEnum") {
      setFechaTCEnumValue(selected);
    }
    if (filter === "fechaEntregaTXTEnum") {
      setFechaEntregaTXTEnumValue(selected);
    }
    if (filter === "fechaCorteNovedadesEnum") {
      setFechaCorteNovedadesEnumValue(selected);
    }
    if (filter === "fechaPagoEnum") {
      setFechaPagoEnumValue(selected);
    }
    if (filter === "fechaAnticipoFacturaEnum") {
      setFechaAnticipoFacturaEnumValue(selected);
    }
  };

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const formik = useFormik({
    initialValues: {
      // TITULO
      clientId,
      subclients: [],
      titulo: "",
      cargo: "",
      // DATOS CLIENTES NUEVOS
      razonSocialAdecco: [],
      modalidadContratacion: "",
      prepagaObraSocial: "",
      domicilioExplotacion: "",
      relevoSalariosBeneficios: "",
      salarioReferenciadoUSD: "",
      fechaTCDia: null,
      fechaTCEnum: 0,
      quienEnviaYQuienHaceAltasAFIP: "",
      artCliente: "",
      fechaEntregaTXTDia: null,
      fechaEntregaTXTEnum: 0,
      // NOMINAS
      firmaF352: "",
      contactoNovedades: "",
      fechaCorteNovedadesDia: null,
      fechaCorteNovedadesEnum: 0,
      convenio: "",
      fechaPagoDia: null,
      fechaPagoEnum: 0,
      modalidadLiquidacion: "",
      particularidadesLiquidacion: "",
      controlaLibroLey: "",
      // FACTURACION
      necesitaOC: "",
      contactoEnvioFactura: "",
      formatoFactura: null,
      fechaAnticipoFacturaDia: null,
      fechaAnticipoFacturaEnum: 0,
      // COBRANZAS
      procesoPagoProveedores: "",
      contactoCobranzas: "",
      horariosAtencionProveedores: "",
      documentacionAdicional: "",
    },

    onSubmit: async (values) => {
      const dataToCreateRelevo = {
        ...values,
        fechaTCEnum: fechaTCEnumValue ? fechaTCEnumValue.value : null,
        fechaEntregaTXTEnum: fechaEntregaTXTEnumValue ? fechaEntregaTXTEnumValue.value : null,
        fechaCorteNovedadesEnum: fechaCorteNovedadesEnumValue ? fechaCorteNovedadesEnumValue.value : null,
        fechaPagoEnum: fechaPagoEnumValue ? fechaPagoEnumValue.value : null,
        fechaAnticipoFacturaEnum: fechaAnticipoFacturaEnumValue ? fechaAnticipoFacturaEnumValue.value : null,
        subclients: subclientsValues.map((e) => e.value) || [],
        razonSocialAdecco: (razonSocialAdeccoValues && razonSocialAdeccoValues.map((e) => e.value)) || [],
      };

      try {
        if (subclientsValues.length === 0) {
          toast.error("Debes seleccionar al menos un subcliente.");
          return;
        }
        const { message } = await createOrUpdateRelevo(dataToCreateRelevo, relevoId);
        toast.success(message);
        toggle();
        reloadRelevos();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      titulo: Yup.string().required("Este campo es requerido."),
      // cargo: Yup.string().required("Este campo es requerido."),
      fechaTCDia: Yup.number()
        .typeError("El valor debe ser un número")
        .min(1, "El valor debe ser mayor o igual a 1")
        .max(31, "El valor debe ser menor o igual a 31")
        .test("is-valid-range", "El valor debe estar entre 1 y 31", (value) => (value >= 1 && value <= 31) || value === null)
        .nullable(),
      fechaEntregaTXTDia: Yup.number()
        .typeError("El valor debe ser un número")
        .min(1, "El valor debe ser mayor o igual a 1")
        .max(31, "El valor debe ser menor o igual a 31")
        .test("is-valid-range", "El valor debe estar entre 1 y 31", (value) => (value >= 1 && value <= 31) || value === null)
        .nullable(),
      fechaCorteNovedadesDia: Yup.number()
        .typeError("El valor debe ser un número")
        .min(1, "El valor debe ser mayor o igual a 1")
        .max(31, "El valor debe ser menor o igual a 31")
        .test("is-valid-range", "El valor debe estar entre 1 y 31", (value) => (value >= 1 && value <= 31) || value === null)
        .nullable(),
      fechaPagoDia: Yup.number()
        .typeError("El valor debe ser un número")
        .min(1, "El valor debe ser mayor o igual a 1")
        .max(31, "El valor debe ser menor o igual a 31")
        .test("is-valid-range", "El valor debe estar entre 1 y 31", (value) => (value >= 1 && value <= 31) || value === null)
        .nullable(),
      fechaAnticipoFacturaDia: Yup.number()
        .typeError("El valor debe ser un número")
        .min(1, "El valor debe ser mayor o igual a 1")
        .max(31, "El valor debe ser menor o igual a 31")
        .test("is-valid-range", "El valor debe estar entre 1 y 31", (value) => (value >= 1 && value <= 31) || value === null)
        .nullable(),
    }),
  });

  useEffect(() => {
    if (valuesFromEdit) {
      formik.setValues(valuesFromEdit);
      setFechaTCEnumValue(fechasClientesNuevosOptions.find((f) => f.value === valuesFromEdit.fechaTCEnum));
      setFechaEntregaTXTEnumValue(fechasClientesNuevosOptions.find((f) => f.value === valuesFromEdit.fechaEntregaTXTEnum));
      setFechaCorteNovedadesEnumValue(fechasClientesNuevosOptions.find((f) => f.value === valuesFromEdit.fechaCorteNovedadesEnum));
      setFechaPagoEnumValue(fechasClientesNuevosOptions.find((f) => f.value === valuesFromEdit.fechaPagoEnum));
      setFechaAnticipoFacturaEnumValue(fechasClientesNuevosOptions.find((f) => f.value === valuesFromEdit.fechaAnticipoFacturaEnum));
      setSubclientesValues(valuesFromEdit.relsRelevoAdministrativoSubcliente.map((e) => ({ label: e.numeroDeLegajo, value: e.itemId })));
      setRazonSocialAdeccoValues(valuesFromEdit.razonSocialAdecco.map((e) => razonSocialAdeccoOptions.find((f) => f.value === e)));
    }
  }, [valuesFromEdit]);

  return (
    <>
      {showCancelModal && <CancelFormModal toggle={toggle} closeModal={() => setShowCancelModal(false)} isOpen={showCancelModal} />}
      <BlurSpinner>
        <Container>
          <form onSubmit={formik.handleSubmit}>
            <div>
              <div className="d-flex flex-column justify-content-between align-items-start">
                {/* TITULO */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1 ">
                    <TemplateHeader> Título </TemplateHeader>
                  </div>
                  <div>
                    <div className="mb-1">
                      <InputText
                        type="text"
                        id="titulo"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.titulo}
                        maxLength={40}
                        placeholder={formik.errors.titulo && formik.touched.titulo ? formik.errors.titulo : ""}
                        style={formik.errors.titulo && formik.touched.titulo ? { borderBottom: "1px solid red" } : null}
                      />
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                      <div className="mb-1">
                        <CustomLabel>Subcliente</CustomLabel>
                        <LabSelect
                          isMulti
                          id="subclients"
                          name="subclients"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={subclientsValues}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingSubclients}
                          disabled={isLoadingSubclients || formik.isSubmitting}
                          options={subClientOptions}
                        />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Cargo</CustomLabel>
                        <InputText
                          type="text"
                          id="cargo"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cargo}
                          maxLength={40}
                          placeholder={formik.errors.cargo && formik.touched.cargo ? formik.errors.cargo : null}
                          style={formik.errors.cargo && formik.touched.cargo ? { borderBottom: "1px solid red" } : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* DATOS CLIENTES NUEVOS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Datos Clientes Nuevos </TemplateHeader>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <div className="mb-1">
                      <CustomLabel>Razón social Adecco</CustomLabel>
                      <LabSelect
                        isMulti
                        id="razonSocialAdecco"
                        name="razonSocialAdecco"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={razonSocialAdeccoValues}
                        placeholder="Seleccionar"
                        isClearable
                        isLoading={isLoadingCompanias}
                        disabled={isLoadingCompanias || formik.isSubmitting}
                        options={razonSocialAdeccoOptions}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="modalidadContratacion"> Modalidad de contratacion laboral</CustomLabel>
                      <InputText
                        type="text"
                        id="modalidadContratacion"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.modalidadContratacion}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="prepagaObraSocial"> Prepaga/Obra Social</CustomLabel>
                      <InputText
                        type="text"
                        id="prepagaObraSocial"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.prepagaObraSocial}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="domicilioExplotacion"> Domicilio de explotación</CustomLabel>
                      <InputText
                        type="text"
                        id="domicilioExplotacion"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.domicilioExplotacion}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="relevoSalariosBeneficios"> Relevo de salarios/Beneficios</CustomLabel>
                      <InputText
                        type="text"
                        id="relevoSalariosBeneficios"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.relevoSalariosBeneficios}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="salarioReferenciadoUSD"> ¿Salario referenciado en USD?</CustomLabel>
                      <InputText
                        type="text"
                        id="salarioReferenciadoUSD"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.salarioReferenciadoUSD}
                        maxLength="100"
                      />
                    </div>

                    <div>
                      <div className="mb-1">
                        <CustomLabel>Fecha de TC</CustomLabel>
                        <LabSelect
                          id="fechaTCEnum"
                          name="fechaTCEnum"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={fechaTCEnumValue}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories || formik.isSubmitting}
                          options={fechasClientesNuevosOptions}
                        />
                      </div>
                      {fechaTCEnumValue && fechaTCEnumValue.value === 100 && (
                        <div className="mb-1">
                          <CustomLabel htmlFor="fechaTCDia">TC (fecha especial)</CustomLabel>
                          <InputText
                            type="number"
                            id="fechaTCDia"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fechaTCDia}
                            onWheel={(e) => e.target.blur()}
                            maxLength={2}
                            style={formik.errors.fechaTCDia && formik.touched.fechaTCDia ? { borderBottom: "1px solid red" } : null}
                          />
                          {formik.errors.fechaTCDia && formik.touched.fechaTCDia && <CustomLabel style={{ color: "red" }}>{formik.errors.fechaTCDia}</CustomLabel>}
                        </div>
                      )}
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="quienEnviaYQuienHaceAltasAFIP"> Si es AA - ¿a quién se envía y quien hace las altas AFIP?</CustomLabel>
                      <InputText
                        type="text"
                        id="quienEnviaYQuienHaceAltasAFIP"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.quienEnviaYQuienHaceAltasAFIP}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="artCliente"> si es AA - ART CLIENTE </CustomLabel>
                      <InputText
                        type="text"
                        id="artCliente"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.artCliente}
                        maxLength="100"
                        style={formik.errors.description && formik.touched.description ? { borderBottom: "1px solid red", color: "red" } : null}
                      />
                    </div>

                    <div>
                      <div className="mb-1">
                        <CustomLabel>si es AA - fecha de entrega de TXT</CustomLabel>
                        <LabSelect
                          id="fechaEntregaTXTEnum"
                          name="fechaEntregaTXTEnum"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={fechaEntregaTXTEnumValue}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories || formik.isSubmitting}
                          options={fechasClientesNuevosOptions}
                        />
                      </div>

                      {fechaEntregaTXTEnumValue && fechaEntregaTXTEnumValue.value === 100 && (
                        <div className="mb-1">
                          <CustomLabel htmlFor="fechaEntregaTXTDia">Entrega de TXT (fecha especial)</CustomLabel>
                          <InputText
                            type="number"
                            id="fechaEntregaTXTDia"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fechaEntregaTXTDia}
                            maxLength={2}
                            onWheel={(e) => e.target.blur()}
                            style={formik.errors.fechaEntregaTXTDia && formik.touched.fechaEntregaTXTDia ? { borderBottom: "1px solid red" } : null}
                          />
                          {formik.errors.fechaEntregaTXTDia && formik.touched.fechaEntregaTXTDia && (
                            <CustomLabel style={{ color: "red" }}>{formik.errors.fechaEntregaTXTDia}</CustomLabel>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* NOMINAS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Nóminas </TemplateHeader>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <div className="mb-1">
                      <CustomLabel htmlFor="firmaF352"> Si es AA - ¿quién firma F 352?</CustomLabel>
                      <InputText
                        type="text"
                        id="firmaF352"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firmaF352}
                        maxLength={40}
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="contactoNovedades"> Contacto para pedido de novedades</CustomLabel>
                      <InputText
                        type="text"
                        id="contactoNovedades"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.contactoNovedades}
                        maxLength="100"
                      />
                    </div>

                    <div>
                      <div className="mb-1">
                        <CustomLabel>Fecha de corte de novedades</CustomLabel>
                        <LabSelect
                          id="fechaCorteNovedadesEnum"
                          name="fechaCorteNovedadesEnum"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={fechaCorteNovedadesEnumValue}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories || formik.isSubmitting}
                          options={fechasClientesNuevosOptions}
                        />
                      </div>

                      {fechaCorteNovedadesEnumValue && fechaCorteNovedadesEnumValue.value === 100 && (
                        <div className="mb-1">
                          <CustomLabel htmlFor="fechaCorteNovedadesDia"> Corte de novedades (fecha especial)</CustomLabel>
                          <InputText
                            type="number"
                            id="fechaCorteNovedadesDia"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fechaCorteNovedadesDia}
                            maxLength={2}
                            onWheel={(e) => e.target.blur()}
                            style={formik.errors.fechaCorteNovedadesDia && formik.touched.fechaCorteNovedadesDia ? { borderBottom: "1px solid red" } : null}
                          />
                          {formik.errors.fechaCorteNovedadesDia && formik.touched.fechaCorteNovedadesDia && (
                            <CustomLabel style={{ color: "red" }}>{formik.errors.fechaCorteNovedadesDia}</CustomLabel>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="convenio"> Convenio</CustomLabel>
                      <InputText
                        type="text"
                        id="convenio"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.convenio}
                        maxLength="100"
                        // placeholder="Domicilio de explotación"
                      />
                    </div>

                    <div>
                      <div className="mb-1">
                        <CustomLabel>Fecha de Pago</CustomLabel>
                        <LabSelect
                          id="fechaPagoEnum"
                          name="fechaPagoEnum"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={fechaPagoEnumValue}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories || formik.isSubmitting}
                          options={fechasClientesNuevosOptions}
                        />
                      </div>

                      {fechaPagoEnumValue && fechaPagoEnumValue.value === 100 && (
                        <div className="mb-1">
                          <CustomLabel htmlFor="fechaPagoDia"> Pago (fecha especial) </CustomLabel>
                          <InputText
                            type="number"
                            id="fechaPagoDia"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fechaPagoDia}
                            maxLength={2}
                            onWheel={(e) => e.target.blur()}
                            style={formik.errors.fechaPagoDia && formik.touched.fechaPagoDia ? { borderBottom: "1px solid red" } : null}
                          />
                          {formik.errors.fechaPagoDia && formik.touched.fechaPagoDia && <CustomLabel style={{ color: "red" }}>{formik.errors.fechaPagoDia}</CustomLabel>}
                        </div>
                      )}
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="modalidadLiquidacion"> Modalidad de liquidación</CustomLabel>
                      <InputText
                        type="text"
                        id="modalidadLiquidacion"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.modalidadLiquidacion}
                        maxLength="100"
                        // placeholder="Relevo de salarios/Beneficios"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="particularidadesLiquidacion"> Particularidades de liquidación</CustomLabel>
                      <InputText
                        type="text"
                        id="particularidadesLiquidacion"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.particularidadesLiquidacion}
                        maxLength="100"
                        // placeholder="Relevo de salarios/Beneficios"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="controlaLibroLey"> ¿Controla libro ley?</CustomLabel>
                      <InputText
                        type="text"
                        id="controlaLibroLey"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.controlaLibroLey}
                        maxLength="100"
                        // placeholder="¿Salario referenciado en USD?"
                      />
                    </div>
                  </div>
                </div>

                {/* FACTURACION */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Facturación </TemplateHeader>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <div className="mb-1">
                      <CustomLabel htmlFor="necesitaOC"> Necesita Oc </CustomLabel>
                      <InputText
                        type="text"
                        id="necesitaOC"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.necesitaOC}
                        maxLength={40}
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="contactoEnvioFactura"> Contacto para envío de factura </CustomLabel>
                      <InputText
                        type="text"
                        id="contactoEnvioFactura"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.contactoEnvioFactura}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="formatoFactura"> Formato de Factura </CustomLabel>
                      <InputText
                        type="text"
                        id="formatoFactura"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.formatoFactura}
                        maxLength="100"
                        // placeholder="Domicilio de explotación"
                      />
                    </div>

                    <div>
                      <div className="mb-1">
                        <CustomLabel>Fecha de anticipo de factura</CustomLabel>
                        <LabSelect
                          id="fechaAnticipoFacturaEnum"
                          name="fechaAnticipoFacturaEnum"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={fechaAnticipoFacturaEnumValue}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories || formik.isSubmitting}
                          options={fechasClientesNuevosOptions}
                        />
                      </div>

                      {fechaAnticipoFacturaEnumValue && fechaAnticipoFacturaEnumValue.value === 100 && (
                        <div className="mb-1">
                          <CustomLabel htmlFor="fechaAnticipoFacturaDia"> Anticipo de factura (fecha especial) </CustomLabel>
                          <InputText
                            type="number"
                            id="fechaAnticipoFacturaDia"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fechaAnticipoFacturaDia}
                            maxLength={2}
                            onWheel={(e) => e.target.blur()}
                            style={formik.errors.fechaAnticipoFacturaDia && formik.touched.fechaAnticipoFacturaDia ? { borderBottom: "1px solid red" } : null}
                          />
                          {formik.errors.fechaAnticipoFacturaDia && formik.touched.fechaAnticipoFacturaDia && (
                            <CustomLabel style={{ color: "red" }}>{formik.errors.fechaAnticipoFacturaDia}</CustomLabel>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* COBRANZAS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Cobranzas </TemplateHeader>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <div className="mb-1">
                      <CustomLabel htmlFor="procesoPagoProveedores"> Proceso de Pago a proveedores </CustomLabel>
                      <InputText
                        type="text"
                        id="procesoPagoProveedores"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.procesoPagoProveedores}
                        maxLength={300}
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="contactoCobranzas"> Contacto cobranzas </CustomLabel>
                      <InputText
                        type="text"
                        id="contactoCobranzas"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.contactoCobranzas}
                        maxLength={40}
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="horariosAtencionProveedores"> Horarios y días atención a proveedores </CustomLabel>
                      <InputText
                        type="text"
                        id="horariosAtencionProveedores"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.horariosAtencionProveedores}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="documentacionAdicional"> Documentacion adicional </CustomLabel>
                      <InputText
                        type="text"
                        id="documentacionAdicional"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.documentacionAdicional}
                        maxLength="100"
                        // placeholder="Domicilio de explotación"
                      />
                    </div>
                  </div>
                </div>

                {/* ------- */}
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={() => setShowCancelModal(true)}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" className="btn" type="submit" disabled={formik.isSubmitting}>
                  Guardar
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </Container>
      </BlurSpinner>
    </>
  );
}
